import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ShowHideTable } from "../../components/ShowHideTable";
import SubHeaderBox from "../../components/SubHeaderBox";
import InventoryVehicleTable from "./Table";
import { getSystemBoundarySubcategory } from "../../../../../apis/Business/InventoryApi";
import inventoryVehicleIcon from "../../../../../assets/design-revamp-company/category-icons/inventory_vehicle_icon.svg";

const InventoryVehicle = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [systemBoundaryVehicle, setSystemBoundaryVehicle] = useState();

  useEffect(() => {
    getSystemBoundarySubcategory({
      businessId: businessId,
      setSystemBoundarySubCategory: setSystemBoundaryVehicle,
      subcategory: "locality_vehicles",
    });
  }, [businessId]);
  return (
    <div className="component-energy-contents">
      <div style={{ marginTop: "12px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <SubHeaderBox
            subTitle={t("INV_VEHICLE")}
            subDescription={t("DESC_INV_VEHICLE")}
            isNormal={true}
            number={"5.1.1"}
            icon={inventoryVehicleIcon}
            showSystemBoundary={true}
            systemBoundaryProps={{
              businessId: businessId,
              systemBoundary: systemBoundaryVehicle,
              setSystemBoundary: setSystemBoundaryVehicle,
              totalObjCategory: "locality_vehicles",
              customStyles: { marginTop: "10px" },
              isInventory: true,
            }}
          />
        </div>

        {showTable && <InventoryVehicleTable businessId={businessId} />}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
    </div>
  );
};

export default InventoryVehicle;
